import React, { useState, useEffect } from 'react'
import Classes from './styles/style.module.css'
import { useDispatch, useSelector } from "react-redux";
import Footer from '../../GlobalComp/Footer/Footer';
import backend from '../../../api';

function ContactUs() {
    const { user } = useSelector((state) => state.auth);
    const [sendMsg, setsendMsg] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const companyInfo = useSelector((state) => state.companyInfo?.info);
    const updateDimensions = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    const [emptyCompanyTypeError, setemptyCompanyTypeError] = useState(false);

    const [formdata, setformdata] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setformdata({
            ...formdata,
            [name]: value,
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();               // stop the form’s default reload

        const { firstName, lastName, email, message } = formdata || {};

        // basic validation
        if (!firstName?.trim() || !lastName?.trim() || !email?.trim() || !message?.trim()) {
            alert('Please fill all fields');
            return;
        }

        const body = {
            fullname: `${firstName.trim()} ${lastName.trim()}`,
            email: email.trim(),
            message: message.trim(),
        };

        try {
            const res = await backend.post('/email/contactus', body);
            if (res?.status === 200) {
                alert('Email sent successfully');
                // optionally clear the form here
            }
        } catch (err) {
            console.error(err);
            alert('Something went wrong while sending the email');
        }
    };


    return (
        <>
            <div className={Classes.backgroundImage} >
                <div className={Classes.navContainer} style={{ boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' }} >
                    <div>
                        <a href="/" style={{ width: 'fit-content' }} >
                            <div className='logo' >
                                <img src={'/logo.png'} alt='PrivacyBot logo' style={{ height: '2.2rem' }} />
                                <h3 style={{ textDecoration: 'none' }} >privacyBot</h3>
                            </div>
                        </a>
                    </div>
                    <nav className={Classes.navMenu}>
                    </nav>
                    <div>
                        <a href="/" className={Classes.flexAlign} >
                            <h5 className={Classes.goBackTxt} >Go back to <span > {user ? 'dashboard' : 'home'} </span> </h5>
                        </a>
                    </div>
                </div>
                <div className={Classes.hero} >
                    <h1>Contact us</h1>
                    <form onSubmit={handleSubmit} className={Classes.form_con} >
                        <div className={Classes.form_con_row} >
                            <input
                                className={Classes.input_field}
                                placeholder='First name'
                                name='firstName'
                                type='text'
                                required
                                value={formdata.firstName}
                                onChange={handleChange}
                            />
                            <input
                                className={Classes.input_field}
                                placeholder='Last name'
                                name='lastName'
                                type='text'
                                required
                                value={formdata.lastName}
                                onChange={handleChange}
                            />
                        </div>
                        <input
                            className={Classes.input_field}
                            placeholder='Email'
                            name='email'
                            type='email'
                            required
                            value={formdata.email}
                            onChange={handleChange}
                        />
                        <textarea
                            rows={5}
                            className={Classes.input_field}
                            placeholder='Message'
                            name='message'
                            type='text'
                            value={formdata.message}
                            onChange={handleChange}
                            required
                        />

                        <div className={Classes.btnCon} >
                            <button type='submit' > <h5 className={Classes.m0} >Send message</h5> </button>
                            {sendMsg &&
                                <div className={Classes.msgCon} >
                                    <img className={Classes.checkmark} src='./icons/check-mark.png' />
                                    <h5> Your inquiry was successfully received. We will get back to you within 48 hours. </h5>
                                </div>
                            }
                        </div>

                    </form>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ContactUs
